import { cn } from "@lib/utils";

export const authFormCardClassName =
  "br-auth-surface w-full max-w-[400px] m-auto flex flex-col gap-6 rounded-3xl border border-border bg-card p-8 text-card-foreground sm:p-10 sm:shadow-elevated text-center";

type AuthFormCardProps = React.PropsWithChildren<{
  className?: string;
}>;

export function AuthFormCard({ children, className }: AuthFormCardProps) {
  return <div className={cn(authFormCardClassName, className)}>{children}</div>;
}

export const authFormTitleClassName =
  "text-3xl font-bold uppercase tracking-wide sm:text-4xl";

export const authFormSubtitleClassName = "text-sm text-muted-foreground";

export const authFormLabelClassName = "mb-1 block font-medium text-foreground";

export const authFormErrorClassName = "mt-1 text-sm text-danger text-left";

export const authFormSubmitClassName =
  "h-11 w-full rounded-lg text-sm font-semibold";
